export default __webpack_public_path__ + "static/media/ill-no-classes-assigned.3bf5ce0f.svg";